<template>
	<div class="layout-topbar">
		<Toast />
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" :src="topbarImage()" style="width: 50%; height: 10%;" />
			<!-- <span style="color:white">{{ $t('eticket') }} </span> -->
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars" style="color:white"></i>
		</button>
		<b style="color:white;font-size: 1.5rem;text-align: center;width: 75%;">{{ $t('Admin Panel') }}</b>
		<!-- <a
			:class="[`topnav-font-size-${fontsizeid}`, 'nav-link', 'mx-2', 'mt-1', 'float-left']"
			aria-current="page"
			style="font-weight: 700; color: white; cursor: pointer; padding: 5px 10px; border-radius: 5px; transition: background-color 0.3s, color 0.3s;"
			@mouseover="hover = true"
			@mouseleave="hover = false"
			:style="{ backgroundColor: hover ? '#f0f0f0' : 'transparent', color: hover ? '#08355c' : 'white' }"
			>
			<span style="white-space: nowrap;">
				 {{ $t('lang') }}
			</span>
			</a> -->
			<a
        :class="[`topnav-font-size-${fontsizeid}`, 'nav-link', 'mx-2', 'mt-1', 'float-left']"
        aria-current="page"
        @click="changeLanguage"
        style="font-weight: 700; color: white; cursor: pointer; padding: 5px 12px; border-radius: 5px; border: 2px solid white; transition: background-color 0.3s, color 0.3s, border-color 0.3s;"
        @mouseover="hover = true"
        @mouseleave="hover = false"
        :style="{ 
          backgroundColor: hover ? '#f0f0f0' : 'transparent', 
          color: hover ? '#08355c' : 'white',
          borderColor: hover ? '#08355c' : 'white'
        }"
      >
        <span style="white-space: nowrap;">
          {{ $t('lang') }}
        </span>
      </a>
		<!-- <a
			:class="[`topnav-font-size-${fontsizeid}`, 'nav-link', 'mx-2', 'mt-1', 'float-left']"
			aria-current="page"
			@click="changeLanguage"
			style="font-weight: 700; color: white"
			>
			<span style="white-space: nowrap;">
				{{ $t('alphabet') }} {{ $t('lang') }}
			</span>
			</a> -->

            <!-- <a :class="[`topnav-font-size-${fontsizeid}`, 'nav-link', `mx-5`, 'mt-1', 'float-right']" aria-current="page" href="#">
                {{ $t('fontSize') }}
                <select class="form-select form-select-sm" style="border-radius: 0.2rem" v-model="fontSize" @change="changeFontSize">
                    <option selected value="s">1</option>
                    <option value="m">1.25</option>
                    <option value="l">1.5</option>
                    <option value="xl">1.75</option>
                    <option value="xxl">2</option>
                </select>
            </a> -->

			<!-- <div :class="[`topnav-font-size-${fontsizeid}`, 'mx-2', 'mt-1', 'float-left']" style="font-weight: 700; color: white;  margin-left: -10px;">
				<label for="languageDropdown" style="margin-right: 8px; ">{{ $t('alphabet') }}</label>
				<select
					id="languageDropdown"
					class="form-select form-select-sm"
					@change="changeLanguage"
					style="display: inline-block; width: auto; font-weight: 700; color: white; background-color:#08355c; border: 1px solid white;"
				>
					<option value="en">{{ $t('english') }}</option>
					<option value="mr">{{ $t('marathi') }}</option>
				</select>
				</div> -->
				

		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li>
				<!-- <button :class="{ 'glowing-bell': notification_count > 0 }" @click="toggleNotification">
					<i class="pi pi-bell"></i>
				</button> -->
				<!-- <button :class="{   'p-link': true, 'layout-topbar-button': true }" @click="toggleNotification">
					<i class="pi pi-bell" v-if="notification_count>0"></i>
                    <i class="pi pi-bell" v-else></i>
					
				</button>				 -->
				&nbsp;&nbsp;
				<Menu ref="notification" style="width: 20% !important;height: 80% !important; overflow: scroll" :model="overlayNotificationItems" :popup="true" >
					<template #end v-if="notification_count>0" >
						<div class="col-12">
						<div class="grid justify-content-between">
							<div class="col-12 md:col-6">
								<div
								class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
								>
								<p style="color: #3F51B5; font-size: 15px; font-weight: 600">
								{{notification_count}}	{{ $t('notification') }}
								</p>
								</div>
							</div>
							<hr>
							<div class="col-12 md:col-6">
								<div
								class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
								>
								<p style="color: #3F51B5; font-size: 14px; font-weight: 650;cursor: pointer;" @click="mark_as_read({},1)">
									{{ $t('mark_as') }}
								</p>
								</div>
							</div>
							</div>
						</div>
						
						<div class="col-12" v-for="(item, index) in notification_list" :key="index">

							<div class="p-fluid formgrid grid hover" @click="mark_as_read(item)" style="cursor: pointer;">
								<div class="field col-12 md:col-2" >
									<div class="flex align-items-center">
										<span class="i-circle-extra_small"  :style="'background-color:#3F51B5'">#</span>
									</div>
									
								</div>
								<div class="field col-12 md:col-10">
									<p class="font-bold">{{item.title}}</p>
									<p >{{item.description}}</p>
									<!-- <p style="text-align: right;color: #3F51B5; font-size: 15px; font-weight: 400">{{ item.date }}</p> -->
								</div>
							</div>
							<hr>
						</div>
					
					</template>
					<template #end v-else>
						<div class="col-12 md:col-12" style="margin-top:25%"></div>
						
						<div class="col-12 md:col-12">
							<div class="center">
								<span class="d-flex center i-circle"  :style="'background-color:#3F51B5'">?</span>
							</div>
							
							<h4 class="d-flex text-center" style="color: #3F51B5; font-size: 20px; font-weight: 800">
							{{ $t('find_noti') }}
							</h4>
						</div>
					</template>
				</Menu>
			</li>
			
			<li >
				<img style="border-radius: 50%; width: 30px; height: 30px;" :src="profile_photo" :alt="profile_photo" v-if="profile_photo">
				<span v-else-if="user_name" class="i_circle_extra_small_no_shadow" :style="'background-color:'+getcolorcode(user_name)">{{convert_name(user_name)}}</span>
			</li>
			&nbsp;&nbsp;&nbsp;&nbsp;
			<li style="margin-top: 5%;">
				
				<label style="color:white;cursor: pointer;" for="" @click="toggleMenu">{{ user_name }}</label>
				<i class="pi pi-angle-down" style="color:white;cursor: pointer;" @click="toggleMenu"></i>
				<Menu ref="menu" :model="overlayMenuItems" :popup="true" >
						<template #end>
                <button @click="logout" v-ripple class="relative overflow-hidden w-full p-link  align-items-center p-2 pl-3 text-color hover:surface-200 border-noround">
					<i style="color: red;" class="pi pi-sign-in"></i>&nbsp;&nbsp;
                    <span class="inline-flex flex-column">
                        <span style="color: red;" class="font-bold">{{ $t('logout') }}</span>
                        
                    </span>
                </button>
            </template>
					</Menu>
			</li>

			
			
		</ul>
		<Dialog
          v-model:visible="UpdateEmailDialog"
		  :breakpoints="{'960px': '75vw'}"
          :style="{ width: '40vw' }"
          :header="$t('email_setting')"
          :modal="true"
		  position="top"
          maximizable 
        >
		<div class="col-12">
			<div class="p-fluid formgrid grid" >
				<div class="field col-12 md:col-1" >
					<InputSwitch v-model="checked" />
				</div> &nbsp;&nbsp;
				<div class="field col-12 md:col-11" >
					<label for="name">{{ $t('update_msg') }}</label>
				</div>
				<div class="field col-12 md:col-12" >
					<b>{{ $t('email_cases') }} :</b><br><br>
						<label for="">* {{ $t('success_msg') }}</label><br>
						<label for="">* {{ $t('informs') }}</label>
				</div>
			</div>
		</div>
		<template #footer>
			<Button :label="$t('save')" @click="update_email" icon="pi pi-check" class="p-button-success"/>
		</template>
		</Dialog>
		<Dialog
          v-model:visible="UpdateUserDialog"
		  :breakpoints="{'960px': '75vw'}"
          :style="{ width: '60vw' }"
          :header="$t('edit_prof')"
          :modal="true"
		  position="top"
        >
		<div class="col-12">
			<div class="p-fluid formgrid grid" style="margin-top: 2%;">
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="name" type="text" v-model="u_name"
							  @keypress="validateNameInput"
							@copy="disableAction" 
                                                @paste="disableAction" 
                                                @drop="disableAction"
                             />
                            <label for="name">{{ $t('name') }}</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="email" type="text" v-model="email" 
							   @copy="disableAction"
                                                @paste="disableAction" @drop="disableAction"
                             />
                            <label for="email">{{ $t('email') }}</label>
                        </span>
                </div>
				<div class="field col-12 md:col-6" style="margin-top: 1%;">
                        <span class="p-float-label">
                            <InputText id="mobile_no" type="text" v-model="mobile_no" maxlength="10"
							@copy="disableAction"
						@paste="disableAction" @drop="disableAction"
                             />
                            <label for="mobile_no">{{ $t('mob_no') }}</label>
                        </span>
                </div>


			
				<div class="field col-12 md:col-3" style="margin-top: 1%;">
                        <FileUpload
                            
                            class="p-button-primary"
                            mode="basic"
                            name="model[]"
                            
                            :auto="true"
                            :custom-upload="true"
							 :accept="'image/*'"
                            :choose-label="$t('profile_photo')"
                            @uploader="handleFileUpload($event)"
                        />
                </div>
				<div class="field col-12 md:col-3" style="margin-top: 1%;">
					<img :src="profile_photo" :alt="profile_photo" v-if="profile_photo"
                                        class="shadow-2" width="70">
                    <img v-else src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                                        class="shadow-2" width="70" />
                </div>
					
			</div>
		</div>
		<template #footer>
		<Button :label="$t('save')" @click="update_user" icon="pi pi-check" class="p-button-success"/>
		</template>
		</Dialog>

		<Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
          :header="$t('chng_pass')"
          :modal="true"
          class="p-fluid"
		  position="top"
        >
		
		 	<!-- <label for="password1" class="block text-900 font-medium text-xl mb-2">Old Password</label>
                <Password id="password1" v-model="old_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 
			<label for="password1" class="block text-900 font-medium text-xl mb-2">New Password</label>
                <Password id="password1" v-model="new_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 
			<label for="password1" class="block text-900 font-medium text-xl mb-2">Confirm Password</label>
                <Password id="password1" v-model="conf_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						
			<Button label="Change Password" class="p-button-rounded p-button-success" @click="change()" /> -->

			<div class="col-12">
				<div class="p-fluid formgrid grid" style="margin-top: 2%">
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="password1" v-model="old_password" type="password" />
							<label>{{ $t('old_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="new_password" v-model="new_password" type="password" />
							<label>{{ $t('new_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="conf_password" v-model="conf_password" type="password" />
							<label>{{ $t('conf_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<Button :label="$t('chng_pass')" class="p-button-rounded p-button-primary" @click="change()" />
					</div>
				</div>
			</div>
		</Dialog>
		<Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
          :header="$t('chng_pass')"
          :modal="true"
          class="p-fluid"
		  position="top"
        >
		
		 	<!-- <label for="password1" class="block text-900 font-medium text-xl mb-2">Old Password</label>
                <Password id="password1" v-model="old_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 
			<label for="password1" class="block text-900 font-medium text-xl mb-2">New Password</label>
                <Password id="password1" v-model="new_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						 
			<label for="password1" class="block text-900 font-medium text-xl mb-2">Confirm Password</label>
                <Password id="password1" v-model="conf_password" placeholder="Password" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"></Password>
						
			<Button label="Change Password" class="p-button-rounded p-button-success" @click="change()" /> -->

			<div class="col-12">
				<div class="p-fluid formgrid grid" style="margin-top: 2%">
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="password1" v-model="old_password" type="password" />
							<label> {{ $t('old_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="new_password" v-model="new_password" type="password" />
							<label>{{ $t('new_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<span class="p-float-label">
							<InputText id="conf_password" v-model="conf_password" type="password" />
							<label>{{ $t('conf_pass') }}</label>
						</span>
					</div>
					<div class="field col-12 md:col-12" style="margin-top: 2%">
						<Button :label="$t('chng_pass')" class="p-button-rounded p-button-primary" @click="change()" />
					</div>
				</div>
			</div>
		</Dialog>
		
	
 
	</div>

	
</template>

<script>
import apis from "@/apis";
import axios from "axios";
import ColorService from "./service/ColorService";
export default {
	data() {
		
			return {
				ColorService:null,
				color_data:[],
				notification_count:0,
				notification_list:[],
				user_name:"",
				profile_photo:"",
				checked:true,
				u_name:"",
				email:"",
				mobile_no:"",
				file:"",
				file_data:{
					filePath:"",
                	contentType: "",
				},
				attachments:"",
				UpdateEmailDialog:false,
				UpdateUserDialog:false,
				conf_password: "",
				new_password: "",
				old_password: "",
				productDialog:false,
				name:"",
				overlayNotificationItems:[],
				overlayMenuItems: [
					{
						
						label: 'Edit Profile',
						icon: 'pi pi-user',
						command: () => {
							
							this.UpdateUserDialog = true;
						}
					},
					{
						
						label: 'Email Setting', 
						icon: 'pi pi-cloud-upload',
						command: () => {
							
							this.UpdateEmailDialog = true;
						}
					},
					{
						
						label: 'Change Password',
						icon: 'pi pi-lock',
						command: () => {
							this.conf_password= "";
							this.new_password= "";
							this.old_password= "";
							this.productDialog = true;
							
          				}
					}
					,
					{
						label: 'Logout',
						icon: 'pi pi-sign-in',
						to:'/',
						
							command: () => {
									
								localStorage.clear();
								this.$router.push("/");
								return false;
						}
						
					},
					
				],
			}
	},
	computed: {
    currentLocale() {
      
      return this.$i18n.locale;
    }
  },
    methods: {
		disableAction(event) {
      event.preventDefault();
    },
	validateNameInput(event) {
            const charCode = event.charCode || event.keyCode;
            if (
                (charCode >= 65 && charCode <= 90) ||  // Uppercase letters
                (charCode >= 97 && charCode <= 122) || // Lowercase letters
                charCode === 32 // Space
            ) {
                return true;
            }
            event.preventDefault(); // Prevent non-alphabet characters
        },
		changeLanguage(lang) {
				if (lang) {
					this.$i18n.locale = lang; // Set the language based on the dropdown value
					console.log(`Language changed to: ${lang}`);
				}
			},
	
		changeLanguage(evt) {
            evt.preventDefault();
            if (this.$i18n.locale == 'en') {
                this.$i18n.locale = 'mr';
            } else {
                this.$i18n.locale = 'en';
            }

			this.overlayMenuItems=	 [
					{
						
						label: this.$t('editProfile'),
						icon: 'pi pi-user',
						command: () => {
							
							this.UpdateUserDialog = true;
						}
					},
					{
						
						label: this.$t('emailSetting'), 
						icon: 'pi pi-cloud-upload',
						command: () => {
							
							this.UpdateEmailDialog = true;
						}
					},
					{
						
						label: this.$t('changePassword'),
						icon: 'pi pi-lock',
						command: () => {
							this.conf_password= "";
							this.new_password= "";
							this.old_password= "";
							this.productDialog = true;
							
          				}
					}
					,
					{
						label: this.$t('logout'),
						icon: 'pi pi-sign-in',
						to:'/',
						
							command: () => {
									
								localStorage.clear();
								this.$router.push("/");
								return false;
						}
						
					},
					
				];

            //this.$store.dispatch('changeLocale', this.$i18n.locale);
            // this.GovLanguage();
        },
		// logout() {
        //     {
        //         this.isLoggedIn = false;
        //         localStorage.setItem('user_id', '');
        //         this.$router.push({ path: '/' });
        //         // localStorage={};
        //     }
        // },
		convert_name(name)
      {
        var x= this.ColorService.convertToSN(name);
        return x.toString();
        
      },
		getcolorcode(name)
      {
        var name=this.convert_name(name)
        var temp=name.substring(0, 1);
        for (let index = 0; index < this.color_data.length; index++) 
        {
         if (this.color_data[index].name==temp) 
         {
            return this.color_data[index].code;
         }
          
        }
      },
		async mark_as_read(item,flag)
		{	
			var details={};
			if (flag==1) 
			{
				 details={
					"user_id": localStorage.getItem("id"),
					"id":"",
					"read_all":'1'
				}
			}
			else
			{
				 details={
					"user_id": localStorage.getItem("id"),
					"id":item._id,
				}
			}
			

				var promise = apis.read_notification(details);
					promise.then((response) => {
						this.getnotificationlist();
						this.getnotificationcount();
					});
		},
		async logout()
		{
			localStorage.clear();
			this.$router.push("/");
			return false;
		},
		async update_email()
		{	
			var status="";
			if (this.checked==true) {
				status="Yes";
			} else {
				status="No"
			}
			let details={
					"user_id": localStorage.getItem("id"),
					"status":status,
    				"type":"Email",
					lang:this.$i18n.locale,
				}

				var promise = apis.updateUserStatus(details);
					promise.then((response) => {
						this.$swal({title:response.data.message , confirmButtonText: this.$t('ok')});
        				this.UpdateEmailDialog = false;
					});
		},	
		async update_user()
		{
			if (this.email == '') {
                this.$toast.add({
                    severity: "error",
                    summary: this.$t('error'),
                    //detail: "Please Enter Email ID",
                    detail:this.$t("email_empty_error"),
                    life: 3000,
                });
                return false;
            }


           
            var emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
            if (!emailPattern.test(this.email)) {
                this.$toast.add({
                    severity: "error",
                    summary: this.$t('error'),
                   // detail: "Invalid Email ID",
                    detail:this.$t("invalid_email"),
                    life: 3000,
                });
                return false;
            }

			var mobilePattern = /^[1-9][0-9]{9}$/;
				if (!mobilePattern.test(this.mobile_no)) {
					this.$toast.add({
						severity: "error",
						summary: this.$t('error'),
						detail: this.$t("invalid_mob"), 
						life: 3000,
					});
					return false;
				}
			let details={
					"user_id": localStorage.getItem("id"),
					"email_id": this.email,
					"profile_image": this.attachments,
					"mobile_number": this.mobile_no,
					"name": this.u_name,
					lang:this.$i18n.locale,
				}

				var promise = apis.updateUserProfile(details);
					promise.then((response) => {
						this.$swal({title:response.data.message , confirmButtonText: this.$t('ok')});
        				this.UpdateUserDialog = false;
					});
		},
		async date_time_prefix() 
        {
            // Get the current date and time
            const currentDateTime = new Date();

            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');

            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');

            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;

            return resultString;
        },

		async handleFileUpload(event) {
    try {
        var fileUp = event.files[0];

        if (!fileUp) {
            return;
        }

        var allowedTypes = ["image/jpeg", "image/png", "image/gif"];

        // Validate file type
        if (!allowedTypes.includes(fileUp.type)) {
            this.$toast.add({
                severity: "error",
                summary: this.$t("error"),
                detail: this.$t("invalid_file_type"), // Ensure this translation exists
                life: 3000,
            });
            return;
        }

        var prefix = await this.date_time_prefix();
        var filename = `${prefix}_${fileUp.name}`;

        this.file_data = {
            filePath: filename,
            contentType: fileUp.type,
        };

        // Upload to AWS
        let response = await apis.upload_to_AWS(this.file_data);

        if (!response.data || !response.data.data) {
            throw new Error("Invalid response from AWS upload API.");
        }

        // Upload file to AWS S3
        await axios.put(response.data.data, fileUp, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": fileUp.type,
            },
        });

        // Update attachment URL
        this.attachments = `https://eticket-docs.s3.ap-south-1.amazonaws.com/${filename}`;
        this.profile_photo = this.attachments;
    } catch (error) {
        console.error("File upload error:", error);
        this.$toast.add({
            severity: "error",
            summary: this.$t("error"),
            detail: this.$t("upload_failed"), // Add a translation key for upload failure
            life: 3000,
        });
    }
},

		// async handleFileUpload(event)
        // {
        //     var fileUp  =   event.files[0];
        //     var file    =   fileUp;
        //     this.file   =   file;
		// 	var allowedTypes = ["image/jpeg", "image/png", "image/gif"];
        //     var prfeix= await this.date_time_prefix();
        //     var filename = prfeix+"_"+file.name;
		// 	if (!allowedTypes.includes(file.type)) {
        //     this.$toast.add({
        //         severity: "error",
        //         summary: this.$t("error"),
        //         detail: this.$t("invalid_file_type"), // Ensure this translation exists
        //         life: 3000,
        //     });
        //     return;
        // }
        //     this.file_data = 
        //     {
        //         filePath:filename,
        //         contentType: file.type,
        //     };

        //     var promise = apis.upload_to_AWS(this.file_data);
        //         promise.then((response) => {
        
        //         axios
        //         .put(response.data.data, file, {
        //             headers: {
        //             "Access-Control-Allow-Origin": "*",
        //             "Content-Type": file.type,
        //             },
        //         })
        //         .then((response) => {
        //           this.attachments="https://eticket-docs.s3.ap-south-1.amazonaws.com/" +filename;
        //           this.profile_photo=this.attachments;
                   
        //         });
        //     });

        // },
		change()
		{
			
			 if (!this.old_password) {
        this.$toast.add({
          severity: "error",
          
		  summary: this.$t("error"),
         // detail: "Please Enter Old password",
		  detail: this.$t("old_password_empty_error"),
          life: 3000,
        });
        return false;
      }
	   if (!this.new_password) {
        this.$toast.add({
          severity: "error",
		  summary: this.$t("error"),
          //detail: "Please Enter New password",
		  detail: this.$t("new_password_empty_error"),
          life: 3000,
        });
        return false;
      }
	   if (!this.conf_password) {
        this.$toast.add({
          severity: "error",
		  summary: this.$t("error"),
         // detail: "Please Enter Confirm password",
		  detail: this.$t("confirm_password_empty_error"),
          life: 3000,
        });
        return false;
      }
	  if (this.conf_password != this.new_password) {
        this.$toast.add({
          severity: "error",
		  summary: this.$t("error"),
         // detail: "Confirm Password Not Match With Password",
		  detail: this.$t("confirm_password_mismatch_error"),
          life: 3000,
        });
        return false;
      }
	 
	  
		//api
      	var data = {
		"user_id": localStorage.getItem("id"),
		"password":this.old_password,
		"new_password":this.new_password,
		lang:this.$i18n.locale,
      };
    
      var promise = apis.passwordreset(data, this.id);
      promise.then((response) => {
     
			this.productDialog = false;
        	this.$swal({title:response.data.message , confirmButtonText: this.$t('ok')});
        	this.update_pass_Dialog = false;
		 	localStorage.clear();
      		this.$router.push("/"); 
      }).catch((error) => {
            //console.log(error);
          	this.productDialog = false;
			this.$swal.fire(error.response.data);
         
          });

			


		
			
		},
			toggleMenu(event) {
				this.$refs.menu.toggle(event);
			},
			async toggleNotification(event)
			{	
				await this.getnotificationlist();
				await this.getnotificationcount();
				this.$refs.notification.toggle(event);
			},
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {

			return this.$i18n.locale=='mr'?  'images/Logonew.png' : "images/Logonew.png";
		},
		async getnotificationlist()
		{	
			var data = {    
							"user_id":localStorage.getItem("id"),
							"status":"Pending",
							"limit":10000,
							"page_no":1,
							"count":false
                       };
                        
                        var promise = apis.userNotification(data);
                        promise.then((response) => {
                            
                            this.notification_list = response.data.data;
                            console.log("🚀 ~ promise.then ~ list:", response.data.data)
                            
                        });
		},
		async getnotificationcount()
		{
			var data = {    
							"user_id":localStorage.getItem("id"),
							"status":"Pending",
							"count":true
                       };
                        
                        var promise = apis.userNotification(data);
                        promise.then((response) => {
                           
                            this.notification_count = response.data.data;
							if (this.notification_count > 0) 
							{
								document.querySelector('div').classList.add('glowing-div');
							} else 
							{
								document.querySelector('div').classList.remove('glowing-div');
							}
                            
                        });
		}
    },
		async mounted(){
			this.ColorService = new ColorService();
			this.ColorService.getColors().then((colors) => {
			this.color_data = colors;});
			
			this.name= localStorage.getItem("email");

			this.u_name=localStorage.getItem("name");
			this.email=localStorage.getItem("email_id");
			this.mobile_no=localStorage.getItem("mobile_number");
			
			var email_notification = localStorage.getItem("email_notification");
			if (email_notification=='Yes') {
				this.checked=true;
			} else {
				this.checked=false;
			}
			this.profile_photo=localStorage.getItem("profile_image");

			var user_type = localStorage.getItem("user_type");
			if (user_type=='Admin') {
				this.user_name='Admin';
			}
			else if(user_type=='Agenct')
			{
				this.user_name='Agent';
			}
			else{
				this.user_name=this.u_name;
			}
			await this.getnotificationlist();
			await this.getnotificationcount();

		},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	}
}
</script>
<style scoped>
.layout-topbar .layout-topbar-logo {
   
    width: 150px;
   
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
 
}

.glowing-bell:hover {
	background-color: #274461 !important;
}
.glowing-bell {
    
    
    
    animation: glow 1s infinite alternate;
  }

  @keyframes glow {
    from {
      box-shadow: 0 0 10px -10px #ffffff;
    }
    to {
      box-shadow: 0 0 10px 5px #ffffff;
    }
  }

  .bell{
  display:block;
  /* width: 40px;
  height: 40px; */
  /* font-size: 40px; */
  /* margin:50px auto 0; */
  color:white;
  -webkit-animation: ring 4s .7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s .7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s .2s ease-in-out infinite;
  transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
  0% { -webkit-transform: rotateZ(0); }
  1% { -webkit-transform: rotateZ(30deg); }
  3% { -webkit-transform: rotateZ(-28deg); }
  5% { -webkit-transform: rotateZ(34deg); }
  7% { -webkit-transform: rotateZ(-32deg); }
  9% { -webkit-transform: rotateZ(30deg); }
  11% { -webkit-transform: rotateZ(-28deg); }
  13% { -webkit-transform: rotateZ(26deg); }
  15% { -webkit-transform: rotateZ(-24deg); }
  17% { -webkit-transform: rotateZ(22deg); }
  19% { -webkit-transform: rotateZ(-20deg); }
  21% { -webkit-transform: rotateZ(18deg); }
  23% { -webkit-transform: rotateZ(-16deg); }
  25% { -webkit-transform: rotateZ(14deg); }
  27% { -webkit-transform: rotateZ(-12deg); }
  29% { -webkit-transform: rotateZ(10deg); }
  31% { -webkit-transform: rotateZ(-8deg); }
  33% { -webkit-transform: rotateZ(6deg); }
  35% { -webkit-transform: rotateZ(-4deg); }
  37% { -webkit-transform: rotateZ(2deg); }
  39% { -webkit-transform: rotateZ(-1deg); }
  41% { -webkit-transform: rotateZ(1deg); }

  43% { -webkit-transform: rotateZ(0); }
  100% { -webkit-transform: rotateZ(0); }
}

@-moz-keyframes ring {
  0% { -moz-transform: rotate(0); }
  1% { -moz-transform: rotate(30deg); }
  3% { -moz-transform: rotate(-28deg); }
  5% { -moz-transform: rotate(34deg); }
  7% { -moz-transform: rotate(-32deg); }
  9% { -moz-transform: rotate(30deg); }
  11% { -moz-transform: rotate(-28deg); }
  13% { -moz-transform: rotate(26deg); }
  15% { -moz-transform: rotate(-24deg); }
  17% { -moz-transform: rotate(22deg); }
  19% { -moz-transform: rotate(-20deg); }
  21% { -moz-transform: rotate(18deg); }
  23% { -moz-transform: rotate(-16deg); }
  25% { -moz-transform: rotate(14deg); }
  27% { -moz-transform: rotate(-12deg); }
  29% { -moz-transform: rotate(10deg); }
  31% { -moz-transform: rotate(-8deg); }
  33% { -moz-transform: rotate(6deg); }
  35% { -moz-transform: rotate(-4deg); }
  37% { -moz-transform: rotate(2deg); }
  39% { -moz-transform: rotate(-1deg); }
  41% { -moz-transform: rotate(1deg); }

  43% { -moz-transform: rotate(0); }
  100% { -moz-transform: rotate(0); }
}

@keyframes ring {
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
}

</style>